import { reactive, toRefs, nextTick } from 'vue'
import { clone } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants'
import { getTargetingData, getTargetingDataById } from '@/api/manage.model'

export function useTargetingList(configForm, updateConfigForm) {
  const targetings = reactive({
    targetingSelectModal: false,
    targetingSelectModalLoading: false,
    targetingTotal: 0,
    targetingList: [],
    showTargetingAddDrawer: false,
    gdtTargetingType: ''
  })

  const onShowAddTargetingFormDrawer = () => {
    targetings.showTargetingAddDrawer = true
  }

  const onSelectConfirm = async (e) => {
    // 由于v--for的key使用的是targetingId，先清空所有定向包，不然相同的定向包id选择不会触发页面更新
    updateConfigForm({ ...configForm.value, targetings: [] })
    await nextTick()
    const targetings = clone(configForm.value.targetings)
    const selectedIds = e.map((i) => i.targetingId)
    const newTargetings = []

    // 获得老定向，且过滤掉当前已选定向
    const lagecyTargetings = targetings.filter((t) => !selectedIds.includes(t.targetingId))
    // 再把新定向添加进去
    newTargetings.push(...lagecyTargetings, ...e)

    // 最多选取100个
    updateConfigForm({
      ...configForm.value,
      targetings: newTargetings.slice(0, 100)
    })
  }
  const queryTargetingData = (filterParams) => {
    const { ch_platform_id } = configForm.value.project || {}
    let params = { mediaId: MEDIAS.GDT, platformId: ch_platform_id, adMarketingScene: targetings.gdtTargetingType, pageIndex: 1, pageSize: 20 }
    if (filterParams) params = Object.assign({}, params, filterParams)

    targetings.targetingSelectModalLoading = true
    getTargetingData(params)
      .then((data) => {
        if (!data || typeof data === 'string') return
        const { list, page_info } = data
        if (list.length && page_info) {
          const { total_number } = page_info
          targetings.targetingTotal = total_number || 0
          targetings.targetingList = list
        } else {
          targetings.targetingList = []
        }
      })
      .finally(() => {
        targetings.targetingSelectModalLoading = false
      })
  }

  return {
    ...toRefs(targetings),
    onShowAddTargetingFormDrawer,
    onSelectConfirm,
    queryTargetingData
  }
}
